export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8697.cc52633d.jpg";